<template>
  <div class="booking-modify-display">
    <span class="fa fa-3x fa-pull-right fa-calendar modify desc"></span>
    <p>
      <strong class="desc">Modified Reservation</strong><br/>
      <strong class="card-title">New Start Date: </strong><br class="show-br" />{{ message.newStartTime | date_format timezone }}<br/>
      <strong class="card-title">New End Date: </strong><br class="show-br" />{{ message.newEndTime | date_format timezone }}<br/>
      <strong class="card-title">Date Modified: </strong><br class="show-br" />{{ message.modifiedAt | date_format timezone }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'BookingModifyDisplay',
  props: {
    message: {
      type: Object
    },
    timezone: {
      type: String
    }
  }
}
</script>



// WEBPACK FOOTER //
// BookingModifyDisplay.vue?263816d4